
import React, { useState, useEffect } from 'react';

import { useRouter } from 'next/router';

import Link from 'next/link';

import { ajaxor0, ajaxor2, isLogon } from '../../../common/basic';
import getNLS from '../../../common/_NLS';
import { genders, seasons } from '../../../../public/CodeData';


import BlackFilter from './black-belt';
import Item from './item';

import CommunityFilter from '../../../popup/CommunityFilter';

import FallbackModal from '../../../popup/Fallback';
import FixedDetail from '../../detail/FixedDetail';
import Classification from '../../../popup/Classification';
import Likers from '../../../popup/PersonList';

export default props=>{
  const router = useRouter();

  if(!process.browser) return <></>;
  const qs = require("querystring");

  const routerOrder = router.query.order || '인기순';
  const following_only = router.query.following_only;


  const [dFixedDetail, setDFixedDetail] = useState('none');
  
  const [dLikersPopup, setDLikersPopup] = useState('none');
  const [vCurrentContentID, setCurrentContentID] = useState(null);

  const [dClassification, setDClassification] = useState('none');
  const [vClassification, setClassification] = useState(null);

  const [dShowmore, setDShowmore] = useState('none');
  const [dShowLoadingBars2, setDShowLoadingBars2] = useState('none');

  // 공유되어 충돌생기는 경우는 렌더링 시마다 setSolid하지 않고, 상태변경에 따른다.
  useEffect(() => {
    setSolid("p6CCList " + dFixedDetail + dClassification + dLikersPopup);
    return () => { ; };
  }, [dFixedDetail, dLikersPopup, dClassification]);

  // const [vThisList, setThisList] = useState([]);
  const [vIndexOfDetail, setIndexOfDetail] = useState(0);
  // 인덱스번호를 가지고 상세팝업을 활성화한다.
  function showDetailByIndex(i){
    setIndexOfDetail(i);
    setDFixedDetail('block');
  }

  const [vTab, setTab] = useState('최신순');
  // 1. 인기순 리스트
  const [vHotList, setHotList] = useState([]);
  const [vHotNavi, setHotNavi] = useState({});
  const [dHotShowmore, setDHotShowmore] = useState('none');
  function goHots(nomination = 0, filter) {
    ajaxor0({
      url: "/inspiration/feed?&order=hot&limit=30"
        + (nomination ? "&page=" + (nomination) : "")
        + "&" + obtainQueryString(),
      callback: callback,
    });
    function callback(r) {
      // console.log("r: ",r);
      nomination
        ? setHotList(vHotList.concat(r.data)) // 지정했으면 append
        : setHotList(r.data); // 지정안했으면 초기화
      setHotNavi(r.pagination);
      if (r.data && r.data.length == 30) setDHotShowmore('block');

    }
  }

  // 2. 최신순 리스트
  const [vLateList, setLateList] = useState([]);
  const [vLateNavi, setLateNavi] = useState({});
  const [dLateShowmore, setDLateShowmore] = useState('none');
  function goLates(nomination = 0, filter) {
    var pageno = nomination ? nomination : 1;
    setDShowLoadingBars2("block");
    ajaxor0({
      url: "/inspiration/feed?&order=new&limit=30"
        + (nomination ? "&page="+(nomination):"")
        + "&" + obtainQueryString(),
      callback: callback,
    });
    function callback(r) {
      nomination
        ? setLateList(vLateList.concat(r.data)) // 지정했으면 append
        : setLateList(r.data); // 지정안했으면 초기화
      setLateNavi(r.pagination);
      if (r.data && r.data.length == 30) setDLateShowmore('block');
      else setDLateShowmore('none');
      setDShowLoadingBars2("none");

    }
  }

  // 3. 팔로잉 리스트
  const [vFollowList, setFollowList] = useState([]);
  const [vFollowNavi, setFollowNavi] = useState({});
  const [dFollowShowmore, setDFollowShowmore] = useState('none');
  function goFollows(nomination = 0, filter) {
    if (!localStorage['loginer']) return;    
    ajaxor0({
      // 210520 내꺼말고 내가팔로잉하는 사람의꺼
      // url: "/user/posts/" + (JSON.parse(localStorage['loginer']).id) + '?limit=30'
      url: "/inspiration/feed?&following_only=1&limit=30"

        + (nomination ? "&page=" + (nomination) : "")
        + "&" + obtainQueryString(),
      callback: callback,
    });
    function callback(r) {
      nomination
        ? setFollowList(vFollowList.concat(r.data)) // 지정했으면 append
        : setFollowList(r.data); // 지정안했으면 초기화
      setFollowNavi(r.pagination);
      if (r.data && r.data.length == 30) setDFollowShowmore('block');
    }
  }


  const tabLabel2List = {
    "인기순": vHotList,
    "최신순": vLateList,
    "팔로잉순": vFollowList,
  };


  // useEffect(() => {
  //   console.log("useEffect[]: 필터이펙트에서 어짜피 로드한다.");
  //   goHots();
  //   goLates();
  //   goFollows();
  //   return () => { ; }
  // }, []);


// 0224 이전버전
  // useEffect(() => {
  //   asyncThisList();
  //   return () => { };
  // }, []);

  // // following_only = 1
  // function asyncThisList() {
  //   console.log("orderBy: ", orderBy, following_only);
  //   var ajaxURL = "/inspiration/feed?limit=30&page="
  //     + parseInt(vThisList.length / 30 + 1)
  //     + (orderBy != undefined ? "&order=" + orderBy : '')
  //     // + (following_only==1?'&following_only=0':'')
  //     ;
  //   if (following_only == 1) ajaxURL = "/user/posts/"
  //     + (JSON.parse(localStorage['loginer']).id)
  //     + '?limit=30&page=' + parseInt(vThisList.length / 30 + 1);

  //   ajaxor2({
  //     url: ajaxURL,
  //     // callback: updateThis,
  //     callback: callback,
  //   });

  //   function callback(r) {
  //     // console.log("r: ",r);
  //     setThisList(vThisList.concat(r));
  //     if (r.length < 30) setDShowmore('none');
  //   }

  // }

  // vTab별
  function showMore() {
    // console.log("show more: ");

    if       (vTab == "인기순") {
      goHots(vHotNavi.current_page+1);
    } else if(vTab == "최신순") {
      goLates(vLateNavi.current_page+1);
    } else if (vTab == "팔로잉순") {
      goFollows(vFollowNavi.current_page+1);
    }

  }

  // const [order,setOrder]=useState('인기순');
  const [dFilter, setFilter] = useState('none');
  const [vCommunityFilter, setCommunityFilter] = useState({ 'gender': '전체', 'season': '전체', 'color': '전체' });

  
  useEffect(() => {
    if (process.browser) setSolid("Filter " + dFilter);
    return () => { ; };
  }, [dFilter]);

// 필터창에서 "적용"시에 사용
  function onChangedFilter(o){
    setFilter('none');
    setCommunityFilter(o);
  }


  useEffect(() => {
    if (!process.browser) return;
    // console.log("vCommunityFilter: ",vCommunityFilter);
    goHots();
    goLates();
    goFollows();

    return () => { ; };
  }, [vCommunityFilter]);

  function obtainQueryString() {
    return qs.stringify(
      {
        gender: genders[vCommunityFilter.gender],
        season: seasons[vCommunityFilter.season],
        color: vCommunityFilter.color,
      }
    );

    // return qs.stringify(
    //   {
    //     gender: genders.indexOf(vCommunityFilter.gender),
    //     season: seasons.indexOf(vCommunityFilter.season),
    //     color: vCommunityFilter.season,
    //   }
    // );
  }

  useEffect(() => {
    // console.log("vLateList: ", vLateList);

    return () => { ; };
  }, [vLateList]);


  // 라이크 클릭시 전역에사용되는 state를 변경한다.
  function anyLikePlus(cid) {
    if (!isLogon()) {
      alert('로그인을 하셔야 합니다.');
      return;
    }

    ajaxor2({
      url: '/inspiration/like/' + cid,
      type: 'post',
      callback: likePresent
    });
    function likePresent(r) {
      // 이탭의 목록을 갱신한다.
      let theList = tabLabel2List[vTab];
      let newList = theList.map((v) => {
        if (v.id == cid) { // 그게시물은 라이크 시킨다.
          v.like_count = v.like_count + (v.liked ? -1 : 1); // 현재라이크상태가 참이면 빼고 아니면 더하고.
          v.liked = !v.liked; // 라이크 반전
        }
        return v;
      });
      setLateList(newList);
    }

  }

  return (<div className="Pan6ArticleList">
    {/* 공통적으로 사용하는 상세팝업 */}
    <FixedDetail
      display={dFixedDetail} hide={() => setDFixedDetail('none')}

      me={vTab && tabLabel2List[vTab][vIndexOfDetail]}
      index={vIndexOfDetail}
      maxListSize={vTab && tabLabel2List && tabLabel2List[vTab] && tabLabel2List[vTab].length}

      move={setIndexOfDetail}

      likePlus={() => anyLikePlus( tabLabel2List[vTab][vIndexOfDetail].id )}
    />
    {/* FixedDetail ==> CommunityDetail */}

    {/* 좋아요한 사람들 팝업 */}
    <FallbackModal display={dLikersPopup} hide={() => setDLikersPopup('none')}
      innerContent={<Likers cid={vCurrentContentID}/>}
    />

    {/* 분류 팝업 */}
    <FallbackModal display={dClassification} hide={() => setDClassification('none')}
      innerContent={<Classification title="" body="" me={vClassification} />}
    />
    <style jsx>{`
.Pan6ArticleList {
  padding-top: 40px;
}


.display-inline{
  display: inline;
  margin: 0 7px;
  vertical-align: middle;
  
}

.tabon.tab {
  font-family: NotoSansCJKkr;
  font-size: 14px;
  color: #343a40;
}

.tab {
  font-family: NotoSansCJKkr;
  font-size: 14px;
  color: #adb5bd;
  margin-right: 12px;
}

.tabled{
  width: 100%;
}

.column{
  width: 426px;
  margin: 0;
  border: 0;
  padding: 5px 15px;
  vertical-align: top;
}


.width100per {
  width: 100%;
  background-color: #4a4a4a;
}

.widen-frame{
  width: 1290px;
  margin: 0 auto;
  padding-top: 10px;
}

@media all and (max-width:606px) {
  .sss{display: none;}
  .widen-frame{width: 100%;}
  .Pan6ArticleList {
    padding: 40px 15px 0 15px;
  }

}

`}</style>

    <div className="width100per">
      <BlackFilter 
        me={
          {
            gender: vCommunityFilter.gender,
            season: vCommunityFilter.season, 
            color: vCommunityFilter.color,
          }
        }
        gender={vCommunityFilter.gender} 
        season={vCommunityFilter.season} 
        color={vCommunityFilter.color} 
        setCommunityFilter={setCommunityFilter}
        
      />
    </div>

    <div className="widen-frame">
      <table><tbody>
        <tr>
          <td align="left">
            {/* <a href="/community/list?order=hot#here"
              className={"tab " + (order =='인기순'?"tabon":"")} 
              onClick={() => setOrder('인기순')}
            >{getNLS("인기순")}</a>
            <a href="/community/list?order=new#here" 
              className={"tab " + (order =='최신순'?"tabon":"")} 
              onClick={() => setOrder('최신순')}
            >{getNLS("최신순")}</a>
            <a href="/community/list?following_only=1#here"
              className={"tab " + (order == '팔로잉순' ? "tabon" : "")}
              onClick={() => setOrder('팔로잉순')}
            >{getNLS("팔로잉순")}</a> */}

            {/* <Link href="/community/list?order=hot#here">
              <a className={"tab " + (order == '인기순' ? "tabon" : "")}
                onClick={() => setOrder('인기순')}
                >{getNLS("인기순")}</a>
            </Link>
            <Link href="/community/list?order=new#here">
              <a className={"tab " + (order == '최신순' ? "tabon" : "")}
                onClick={() => setOrder('최신순')}
              >{getNLS("최신순")}</a>
            </Link>
            <Link href="/community/list?following_only=1#here">
              <a className={"tab " + (order =='팔로잉순'?"tabon":"")} 
                onClick={() => setOrder('팔로잉순')}
              >{getNLS("팔로잉순")}</a>
            </Link> */}



            {/* <a onClick={() => setTab('인기순')}>
              <div className={"dib tab " + (vTab == "인기순" ? "tabon" : "")} >
                포스트 {vPostNavi && vPostNavi.total}
              </div>
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a onClick={() => setTab('최신순')}>
              <div className={"dib tab " + (vTab == "최신순" ? "tabon" : "")}>
                스크랩 {vScrapNavi && vScrapNavi.total}
              </div>
            </a> */}

            <a className={"tab " + (vTab == '인기순' ? "tabon" : "")}
              onClick={() => setTab('인기순')}
            >{getNLS("인기순")}</a>
            <a className={"tab " + (vTab == '최신순' ? "tabon" : "")}
              onClick={() => setTab('최신순')}
            >{getNLS("최신순")}</a>
            <a className={"tab " + (vTab == '팔로잉순' ? "tabon" : "")}
              onClick={() => setTab('팔로잉순')}
            >{getNLS("팔로잉순")}</a>


          </td>

          <td align="right">
            <div>
              <a onClick={() => setFilter('block')}><img src="/assets/images/filter@2x.png" /></a>
            </div>
            <FallbackModal display={dFilter} hide={() => setFilter('none')}
              innerContent={
                <CommunityFilter hide={() => setFilter('none')} 
                  communityFilter={vCommunityFilter}
                  save={onChangedFilter}
                />
              }
            />

          </td>
        </tr></tbody></table>
    </div>
    <div>&nbsp;</div>

    <style jsx>{`

* { box-sizing: border-box; }

.grid-container{
    width: 1290px;
    margin: auto;
    display: grid;

    grid-template-columns: 416px 416px 416px;
    grid-column-gap: 21px;
    grid-row-gap: 21px;

  }

.grid-item{
}

@media all and (max-width:606px) {
  .base{}

  .grid-container{
    width: 100%;
    height: initial;
    grid-template-columns: auto;
    /* padding: 0 15px; 일과이분의일작업으로 이미지가 안보였는데 그걸고치니 패딩이 필요없어졌다. */
  }

}

`}</style>
    <div className="center loadingbars2" style={{ display: dShowLoadingBars2 }}>
      <img className="loadingbars2" src="/assets/loadingbars2.gif" />
    </div>

    {/* 게시물 목록 */}
    <div id="here" className="grid-container">
      {
        (vTab && (typeof tabLabel2List[vTab] !='undefined') && tabLabel2List[vTab])
        .map((v, i) =>
        <div key={i} className="grid-item">
          <Item me={v}
            setDFixedDetail={()=>showDetailByIndex(i)}

            showLikersPopup={() => {
              setCurrentContentID(v.id);
              setDLikersPopup('block');
            }}
            setDClassification={() => {
              setClassification(v.images[0].pins);
              setDClassification('block');
            }}

            likePlus={()=>anyLikePlus(v.id)}
          />
        </div>
      )}
    </div>

    <div className="see-more"
      // onClick={asyncThisList}
      // style={{ display: dShowmore }}
      onClick={showMore}
      style={{ display: (
        (vTab=="인기순")?dHotShowmore:
        (vTab == "최신순") ? dLateShowmore :
          (vTab == "팔로잉순") ? dFollowShowmore :"")
          }}
    >+ {getNLS("더 보기")}</div>
    
  </div>);
}